import { Resource } from 'i18next';

import zodTranslationEn from 'zod-i18n-map/locales/en/zod.json';
import zodTranslationPl from 'zod-i18n-map/locales/pl/zod.json';
import zodTranslationNo from 'zod-i18n-map/locales/nb/zod.json';
import zodTranslationEs from 'zod-i18n-map/locales/es/zod.json';

import { LanguagesResources } from '../consts';
import { formLocales } from '../form';

const FORM_NS = 'form';

const zodLocales: LanguagesResources = {
	en: zodTranslationEn,
	pl: zodTranslationPl,
	no: zodTranslationNo,
	es: zodTranslationEs,
};

function getResourcesWithZod(resources: Resource): Resource | undefined {
	return Object.fromEntries(
		Object.entries(resources).map(([lang, resource]) => [
			lang,
			hasZodLocale(lang)
				? { ...resource, zod: zodLocales[lang], [FORM_NS]: formLocales[lang] }
				: resource,
		]),
	);
}

function hasZodLocale(languageKey: string): languageKey is keyof typeof zodLocales {
	return languageKey in zodLocales;
}

export { FORM_NS, getResourcesWithZod };
